import PropTypes from 'prop-types';
import LoginDialogImpl from './login-dialog.jsx';
import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import { noop } from 'mojito/utils';
const { STATES } = MojitoServices.Authentication.types;

const UIView = MojitoCore.Presentation.UIView;

/**
 * A login dialog component.
 *
 * @class LoginDialog
 * @memberof Mojito.Presentation.Components
 */

/**
 * `LoginDialog` component prop types.
 *
 * @property {boolean} isVisible - Indicates whether the dialog should be visible.
 * @property {Function} [onClose = ()=>{}] - Callback function invoked when dialog should be closed.
 * @property {Function} [onLogin = ()=>{}] - Callback function invoked when user click on login button.
 * @property {Mojito.Services.Authentication.types.STATES} [loginState = STATES.UNKNOWN] - User login state.
 * @property {Mojito.Core.Services.Transactions.types.Error} errorInfo - Login error info object.
 * @property {string} [logoutReason = ''] - The reason that app was logged out.
 * @property {string} [title] - The title string to display. The `LOGIN_DIALOG.HEADER` will be used if not specified.
 *
 * @memberof Mojito.Presentation.Components.LoginDialog
 */
const propTypes = {
    isVisible: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onLogin: PropTypes.func,
    loginState: PropTypes.string,
    errorInfo: PropTypes.object,
    logoutReason: PropTypes.string,
    title: PropTypes.string,
};

const defaultProps = {
    onClose: noop,
    onLogin: noop,
    loginState: STATES.UNKNOWN,
    logoutReason: '',
};

export default UIView('LoginDialog', LoginDialogImpl, propTypes, defaultProps);
